import React from 'react';

import PropTypes from 'prop-types';

export default function FilterIcon({
  color = '#1B1C19',
  height = 14,
  width = 16,
  ...rest
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 16 14"
      fill="none"
      {...rest}
    >
      <path
        d="M0 2.8C0 2.61435 0.070238 2.4363 0.195262 2.30503C0.320287 2.17375 0.489856 2.1 0.666667 2.1H3.33333C3.51014 2.1 3.67971 2.17375 3.80474 2.30503C3.92976 2.4363 4 2.61435 4 2.8C4 2.98565 3.92976 3.1637 3.80474 3.29497C3.67971 3.42625 3.51014 3.5 3.33333 3.5H0.666667C0.489856 3.5 0.320287 3.42625 0.195262 3.29497C0.070238 3.1637 0 2.98565 0 2.8ZM15.3333 10.5H12V9.1C12 8.91435 11.9298 8.7363 11.8047 8.60502C11.6797 8.47375 11.5101 8.4 11.3333 8.4C11.1565 8.4 10.987 8.47375 10.8619 8.60502C10.7369 8.7363 10.6667 8.91435 10.6667 9.1V13.3C10.6667 13.4857 10.7369 13.6637 10.8619 13.795C10.987 13.9263 11.1565 14 11.3333 14C11.5101 14 11.6797 13.9263 11.8047 13.795C11.9298 13.6637 12 13.4857 12 13.3V11.9H15.3333C15.5101 11.9 15.6797 11.8263 15.8047 11.695C15.9298 11.5637 16 11.3857 16 11.2C16 11.0143 15.9298 10.8363 15.8047 10.705C15.6797 10.5737 15.5101 10.5 15.3333 10.5ZM8.66667 10.5H0.666667C0.489856 10.5 0.320287 10.5737 0.195262 10.705C0.070238 10.8363 0 11.0143 0 11.2C0 11.3857 0.070238 11.5637 0.195262 11.695C0.320287 11.8263 0.489856 11.9 0.666667 11.9H8.66667C8.84348 11.9 9.01305 11.8263 9.13807 11.695C9.2631 11.5637 9.33333 11.3857 9.33333 11.2C9.33333 11.0143 9.2631 10.8363 9.13807 10.705C9.01305 10.5737 8.84348 10.5 8.66667 10.5ZM6 5.6C6.17681 5.6 6.34638 5.52625 6.4714 5.39497C6.59643 5.2637 6.66667 5.08565 6.66667 4.9V3.5H15.3333C15.5101 3.5 15.6797 3.42625 15.8047 3.29497C15.9298 3.1637 16 2.98565 16 2.8C16 2.61435 15.9298 2.4363 15.8047 2.30503C15.6797 2.17375 15.5101 2.1 15.3333 2.1H6.66667V0.7C6.66667 0.514348 6.59643 0.336301 6.4714 0.205025C6.34638 0.0737499 6.17681 0 6 0C5.82319 0 5.65362 0.0737499 5.5286 0.205025C5.40357 0.336301 5.33333 0.514348 5.33333 0.7V4.9C5.33333 5.08565 5.40357 5.2637 5.5286 5.39497C5.65362 5.52625 5.82319 5.6 6 5.6Z"
        fill={color}
      />
    </svg>
  );
}

FilterIcon.propTypes = {
  color: PropTypes.string,
  height: PropTypes.number,
  width: PropTypes.number,
};
